import styled, { css, keyframes } from "styled-components";
import { colors, darkModeColors } from "../../consts";
import { device } from "../../services";
import { FlexContainers, Heading4, WhiteContainer } from "../../components";

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateX(30%);
    }
    to {
        opacity: 1;
        transform: translateX(0%);
    }
`;

export const Header = styled(FlexContainers.FlexRowBetween)`
  align-items: start;
  margin-bottom: 16px;
  padding-right: 32px;
  padding-left: 32px;
  padding-top: 30px;
  width: 100%;
`;

export const Footer = styled(FlexContainers.FlexRowEnd)`
  width: 100%;
  padding-top: 13px;
  padding-bottom: 32px;
  padding-right: 32px;
  padding-left: 32px;
`;

export const ModalContainer = styled(WhiteContainer)`
  position: relative;
  max-width: 910px;
  ${(props) => props?.backgroundColor && `background-color: ${props.backgroundColor};`}

  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.16);

  overflow: ${(props) => (props?.preventContentScroll ? "visible" : "scroll")};

  ::-webkit-scrollbar {
    height: 0;
  }

  ::-webkit-scrollbar-track-piece {
    margin-block-start: 10px;
    margin-block-end: 5px;
  }

  ${Heading4} {
    font-size: 24px;
    line-height: 34px;
  }

  #close-button {
    margin-left: 22px;
    margin-right: -7px;
    margin-top: -7px;
  }

  @media screen and ${device.laptop} {
    max-width: 768px;
  }

  @media screen and ${device.tablet} {
    max-width: 600px;
  }

  @media screen and ${device.mobile} {
    padding: 22px;

    #close-button {
      margin-left: 22px;
      margin-right: -6px;
      margin-top: -6px;
    }
  }
`;

export const ModalContent = styled.div`
  position: relative;
  max-height: 78vh;
  width: 100%;
  overflow-x: ${(props) =>
    props.hideContentOverflow ? "hidden" : !props.preventOverflow ? "auto" : "visible"};
  overflow-y: auto;

  padding: ${(props) => (props.hasHeader ? "6px" : "24px")} 32px
    ${(props) => (props.hasFooter ? "6px" : "24px")};

  ${(props) =>
    (((props.isOverflow || props.showFooterBorder) && props.hasFooter) ||
      props.withContentVerticalBorders) &&
    `border-bottom: 1px solid ${colors.RAISIN_40};`}

  ${(props) =>
    ((props.isOverflow && props.hasHeader) || props.withContentVerticalBorders) &&
    `border-top: 1px solid ${colors.RAISIN_40};`}


  @media screen and ${device.tablet} {
    margin-right: -16px;
    padding-right: 16px;
  }

  @media screen and ${device.mobile} {
    margin-right: -11px;
    padding-right: 11px;
  }

  ::-webkit-scrollbar {
    border-radius: 8px;
    width: 4px;
    margin-left: 20px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${colors.RAISIN_40};
    border-radius: 8px;

    margin-left: 20px;
  }
`;

export const ModalBackground = styled(FlexContainers.FlexColumnCenter)`
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  position: fixed;
  z-index: -100;

  background: ${(props) =>
    props.theme.darkMode ? `rgba(52, 48, 61, 0.48)` : `rgba(52, 48, 61, 0.48)`};

  opacity: 0;
  pointer-events: none;

  &.active {
    opacity: 1;
    pointer-events: all;
    z-index: 100;
  }

  ${(props) => props?.isFullHeight && "justify-content: start;"}
  ${(props) => props?.alignRight && "align-items: end;"}

  & ${ModalContainer} {
    height: ${(props) => (props?.isFullHeight ? "100%" : "unset")};
    ${(props) => props?.isFullHeight && "justify-content: start;"}
    ${(props) =>
      props?.alignRight &&
      `
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    `}
  }
`;

const ModalContentFullScreen = css`
  position: absolute;
  top: 0;
  right: -30px;
  pointer-events: all;

  overflow: scroll;
  padding-right: 25px;

  width: 450px;
  height: calc(100vh - 134px - 101px);
`;

export const ModalContentContainer = styled.div`
  ${(props) => props?.alignRight && `${ModalContentFullScreen}`}
`;

export const RightSideModalBackground = styled(FlexContainers.FlexColumnEnd)`
  position: fixed !important;
  top: 14px;
  right: 14px;
  z-index: 1000;

  &:not(.active) {
    display: none;
  }
`;

export const RightSideModalContainer = styled.div`
  border-radius: 16px;
  background: ${darkModeColors.WHITE_RAISIN_100};
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);

  animation: ${fadeIn} 0.3s ease-in;

  padding: 24px 16px 24px 24px;
`;

export const ModalVerticalOverflowWrapper = styled.div`
  @media (max-height: 884px) {
    padding-bottom: 32px;
  }
`;
